export default __webpack_public_path__ + "static/media/profileimage.d0bfd263.jpg";